import download from "downloadjs";

export function downloadCsv(content, name) {
  const blob = new Blob(
    [
      new Uint8Array([0xef, 0xbb, 0xbf]), // UTF-8 BOM
      content,
    ],
    { type: "text/csv;charset=utf-8" }
  );

  download(blob, `${name}.csv`, "text/csv");
}
